const optionGroupIsConfigured = (og, configuredOptions) =>
  configuredOptions.some(
    y => og.id === y.id && y.options?.length === og.quantity,
  );

const minMaxOptionGroupIsConfigured = (og, configuredOptions) =>
  configuredOptions.some(
    configuredOG =>
      og.id === configuredOG.id &&
      configuredOG.options?.length >= og.minQuantity &&
      configuredOG.options?.length <= og.maxQuantity,
  );

const isConfiguredOption = (og, configuredOptions) => {
  // this validation is added to verify not required products and products that not has limit
  if (!og.maxQuantity && !og.quantity) {
    return true;
  }

  if (!og.maxQuantity && og.quantity !== 0) {
    return optionGroupIsConfigured(og, configuredOptions);
  }
  if (og.minQuantity > 0 && og.maxQuantity > 0) {
    return minMaxOptionGroupIsConfigured(og, configuredOptions);
  }

  return true;
};

export default function getNotSubmittedOptions(product, configuredOptions) {
  if (!product || !configuredOptions) return [];
  return product.optionGroups?.filter(
    og => !isConfiguredOption(og, configuredOptions),
  );
}
